import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Statistic,
  Spin,
  Col,
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TopContent from "../../../../components/layouts/TopContent";
import appLabel from "../../../../config/appLabel";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import definedApi from "../../../../services/definedApi";
import dayjs from "dayjs";
import { newGlAccountAction } from "../../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import NewLoanAccForm from "./components/NewLoanAccForm";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const NewLoanAccount = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [allowPartialPeriodInterestCalcualtion, setAllowPartialPeriodInterestCalcualtion] =
    useState(false);
  const [isEqualAmortization, setIsEqualAmortization] = useState(false);
  const [customerDetail, setCustomerDetail] = useState([]);
  const [customerId, setCustomerId] = useState([]);
  const [productData, setProductData] = useState([]);
  const [loanOfficerOptions, setLoanOfficerOptions] = useState([]);
  const [loanPurposeOptions, setLoanPurposeOptions] = useState([]);
  const [fundOptions, setFundOptions] = useState([]);
  const [termFrequencyTypeOptions, setTermFrequencyTypeOptions] = useState([]);
  const [repaymentFrequencyTypeOptions, setRepaymentFrequencyTypeOptions] = useState([]);
  const [repaymentFrequencyNthDayTypeOptions, setRepaymentFrequencyNthDayTypeOptions] = useState(
    [],
  );
  const [repaymentFrequencyDaysOfWeekTypeOptions, setRepaymentFrequencyDaysOfWeekTypeOptions] =
    useState([]);
  const [interestTypeOptions, setInterestTypeOptions] = useState([]);
  const [amortizationTypeOptions, setAmortizationTypeOptions] = useState([]);
  const [interestCalculationPeriodTypeOptions, setInterestCalculationPeriodTypeOptions] = useState(
    [],
  );
  const [transactionProcessingStrategyOptions, setTransactionProcessingStrategyOptions] = useState(
    [],
  );
  const [chargeOptions, setChargeOptions] = useState([]);
  const [loanCollateralOptions, setLoanCollateralOptions] = useState([]);
  const [loanAccountDetails, setLoanAccountDetails] = useState([]);
  const [accountLinkingOptions, setAccountLinkingOptions] = useState([]);
  const [productTemplate, setProductTemplate] = useState([]);
  const [customerParam, setCustomerParam] = useState({});
  const [searchParam, setSearchParam] = useState([]);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [penaltyTableSource, setPenaltyTableSource] = useState([]);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [isProductSelected, setIsProductSelected] = useState(false);

  useEffect(() => {}, []);

  const handleAllowPartialPeriodInterestCalcualtion = (e) => {
    setAllowPartialPeriodInterestCalcualtion(e.target.checked);
  };

  const handleIsEqualAmortization = (e) => {
    setIsEqualAmortization(e.target.checked);
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }

  const getProductTemplate = (customerParam) => {
    const params = {
      activeOnly: true,
      clientId: customerParam.entityId,
      staffInSelectedOfficeOnly: true,
      templateType: "individual",
    };
    const url = `${apiConfig.LoanAccounts}/template`;

    let body = {
      session,
      params,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;

        let tempProducts = [];
        let tempLoanOfficerOptions = [];

        objList?.productOptions?.forEach((element) => {
          tempProducts.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.loanOfficerOptions?.forEach((element) => {
          tempLoanOfficerOptions.push({
            value: element.id,
            label: element.displayName,
          });
        });

        setLoanOfficerOptions(tempLoanOfficerOptions);
        setProductData(tempProducts);
        setShowDetailsForm(true);
        // setCustomerInfo(customerParam);
        setIsLoading(false);
      }
    });
  };

  const onChangeProduct = (productParam) => {
    const params = {
      activeOnly: true,
      clientId: customerInfo.entityId,
      productId: productParam,
      staffInSelectedOfficeOnly: true,
      templateType: "individual",
    };
    const url = `${apiConfig.LoanAccounts}/template`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;

        setLoanAccountDetails(objList);
        setProductTemplate(objList);

        let tempLoanPurposeOptions = [];
        let tempFundOptions = [];
        let tempTermFrequencyTypeOptions = [];
        let tempRepaymentFrequencyTypeOptions = [];
        let tempRepaymentFrequencyNthDayTypeOptions = [];
        let tempRepaymentFrequencyDaysOfWeekTypeOptions = [];
        let tempInterestTypeOptions = [];
        let tempAmortizationTypeOptions = [];
        let tempInterestCalculationPeriodTypeOptions = [];
        let tempTransactionProcessingStrategyOptions = [];
        let tempChargeOptions = [];
        let tempLoanCollateralOptions = [];
        let tempCharges = [];
        let tempPenalty = [];

        const tempAccountLinking = [];

        objList?.fundOptions?.forEach((element) => {
          tempFundOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.loanPurposeOptions?.forEach((element) => {
          tempLoanPurposeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.termFrequencyTypeOptions?.forEach((element) => {
          tempTermFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.repaymentFrequencyTypeOptions?.forEach((element) => {
          tempRepaymentFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.repaymentFrequencyNthDayTypeOptions?.forEach((element) => {
          tempRepaymentFrequencyNthDayTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.repaymentFrequencyDaysOfWeekTypeOptions?.forEach((element) => {
          tempRepaymentFrequencyDaysOfWeekTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestTypeOptions?.forEach((element) => {
          tempInterestTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.amortizationTypeOptions?.forEach((element) => {
          tempAmortizationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.interestCalculationPeriodTypeOptions?.forEach((element) => {
          tempInterestCalculationPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.transactionProcessingStrategyOptions?.forEach((element) => {
          tempTransactionProcessingStrategyOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.chargeOptions?.forEach((element) => {
          tempChargeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic value={element?.amount} precision={2} valueStyle={{ fontSize: "16px" }} />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
            feeOnMonthDay: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",
            feeInterval: element?.feeInterval?.value ? element?.feeInterval?.value : "-",
          });
        });

        objList?.overdueCharges?.forEach((element, index) => {
          tempPenalty.push({
            key: index + 1,
            id: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic value={element?.amount} precision={2} valueStyle={{ fontSize: "16px" }} />
            ) : (
              0
            ),
            collectedOn: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
          });
        });

        objList?.loanCollateralOptions?.forEach((element) => {
          tempLoanCollateralOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.accountLinkingOptions?.forEach((element) => {
          tempAccountLinking.push({
            value: element.id,
            label: `${element.productName} - ${element.accountNo}`,
          });
        });

        setLoanPurposeOptions(tempLoanPurposeOptions);
        setFundOptions(tempFundOptions);
        setTermFrequencyTypeOptions(tempTermFrequencyTypeOptions);
        setRepaymentFrequencyTypeOptions(tempRepaymentFrequencyTypeOptions);
        setRepaymentFrequencyNthDayTypeOptions(tempRepaymentFrequencyNthDayTypeOptions);
        setRepaymentFrequencyDaysOfWeekTypeOptions(tempRepaymentFrequencyDaysOfWeekTypeOptions);
        setInterestTypeOptions(tempInterestTypeOptions);
        setAmortizationTypeOptions(tempAmortizationTypeOptions);
        setInterestCalculationPeriodTypeOptions(tempInterestCalculationPeriodTypeOptions);
        setTransactionProcessingStrategyOptions(tempTransactionProcessingStrategyOptions);
        setChargeOptions(tempChargeOptions);
        setLoanCollateralOptions(tempLoanCollateralOptions);
        setAccountLinkingOptions(tempAccountLinking);
        setChargeTableSource(tempCharges);
        setPenaltyTableSource(tempPenalty);

        useForm.setFieldsValue({
          principal: objList?.principal,
          fundId: objList?.fundId,
          loanTermFrequency: objList?.termFrequency,
          repaymentEvery: objList?.repaymentEvery,
          numberOfRepayments: objList?.numberOfRepayments,
          interestRatePerPeriod: objList?.interestRatePerPeriod,
          interestType: objList?.interestType?.id,
          repaymentFrequencyType: objList?.repaymentFrequencyType?.id,
          loanTermFrequencyType: objList?.termPeriodFrequencyType?.id,
          amortizationType: objList?.amortizationType?.id,
          interestCalculationPeriodType: objList?.interestCalculationPeriodType?.id,
          transactionProcessingStrategyId: objList?.transactionProcessingStrategyId,
          maxOutstandingLoanBalance: objList?.maxOutstandingLoanBalance,
          daysInMonth: objList?.daysInMonthType?.value,
          daysinYear: objList?.daysInYearType?.value,
          interestRecalculationCompounding:
            objList?.interestRecalculationData?.interestRecalculationCompoundingType?.value,
          FrequencyForRecalculate:
            objList?.interestRecalculationData?.recalculationRestFrequencyType?.value,
          advancePayments: objList?.interestRecalculationData?.rescheduleStrategyType?.value,
          isInterestRecalculationEnabled: objList?.isInterestRecalculationEnabled,
          recalculationCompoundingFrequency:
            objList?.interestRecalculationData?.recalculationCompoundingFrequencyType?.value,
          inArrearsTolerance: objList?.inArrearsTolerance,
          allowPartialPeriodInterestCalcualtion: objList?.allowPartialPeriodInterestCalcualtion,
          isEqualAmortization: objList?.isEqualAmortization,
          graceOnInterestCharged: objList?.graceOnInterestCharged,
          graceOnPrincipalPayment: objList?.graceOnPrincipalPayment,
          graceOnInterestPayment: objList?.graceOnInterestPayment,
          graceOnArrearsAgeing: objList?.graceOnArrearsAgeing,
          nominalInterestRateFrequency: objList?.interestRateFrequencyType?.value,
          submittedOnDate: dayjs(),
        });
        setIsProductSelected(true);
        setIsLoading(false);
      }
    });
  };

  const onSearch = () => {
    //clear form
    setIsProductSelected(false);
    useForm.resetFields();

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        // setSearchParam("");
      } else {
        const objList = res;
        let tempProducts = [];

        objList?.forEach((element) => {
          tempProducts.push({
            entityAccountNo: element.entityAccountNo ? element.entityAccountNo : "",
            entityId: element.entityId ? element.entityId : "",
            entityMobileNo: element.entityMobileNo ? element.entityMobileNo : "",
            entityName: element.entityName ? element.entityName : "",
            entityType: element.entityType ? element.entityType : "",
          });
        });

        // console.log(tempProducts[0]);
        // return;

        if (tempProducts[0] === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerParam(tempProducts[0]);
        setCustomerInfo(tempProducts[0]);
        getProductTemplate(tempProducts[0]);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.newLoanAccount}
        pageItems={staticConfig.newLoanAccountsBreadcrumbs}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {labelConfig.accountSetup}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <NewLoanAccForm
            accountLinkingOptions={accountLinkingOptions}
            customerDetail={customerDetail}
            productData={productData}
            onChangeProduct={onChangeProduct}
            loanOfficerOptions={loanOfficerOptions}
            loanPurposeOptions={loanPurposeOptions}
            fundOptions={fundOptions}
            termFrequencyTypeOptions={termFrequencyTypeOptions}
            repaymentFrequencyTypeOptions={repaymentFrequencyTypeOptions}
            repaymentFrequencyNthDayTypeOptions={repaymentFrequencyNthDayTypeOptions}
            repaymentFrequencyDaysOfWeekTypeOptions={repaymentFrequencyDaysOfWeekTypeOptions}
            interestTypeOptions={interestTypeOptions}
            amortizationTypeOptions={amortizationTypeOptions}
            interestCalculationPeriodTypeOptions={interestCalculationPeriodTypeOptions}
            transactionProcessingStrategyOptions={transactionProcessingStrategyOptions}
            chargeOptions={chargeOptions}
            loanCollateralOptions={loanCollateralOptions}
            loanAccountDetails={loanAccountDetails}
            form={useForm}
            onSearch={onSearch}
            handleSearchInTable={handleSearchInTable}
            customerInfo={customerInfo}
            showDetailsForm={showDetailsForm}
            allowPartialPeriodInterestCalcualtion={allowPartialPeriodInterestCalcualtion}
            handleAllowPartialPeriodInterestCalcualtion={
              handleAllowPartialPeriodInterestCalcualtion
            }
            isEqualAmortization={isEqualAmortization}
            handleIsEqualAmortization={handleIsEqualAmortization}
            productTemplate={productTemplate}
            isProductSelected={isProductSelected}
            setIsProductSelected={setIsProductSelected}
            chargeTableSource={chargeTableSource}
            setChargeTableSource={setChargeTableSource}
            penaltyTableSource={penaltyTableSource}
          />
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(NewLoanAccount);
